package uz.ferro.shop.pages.admin.debt.model

import kotlinx.serialization.Serializable

@Serializable
data class CustomerDebt(
    val businessPartnerId: String,
    val businessPartnerName: String?,
    val saldo: Double?,
    var expiredAmount: Double? = null,
    var items: MutableList<DebtItem> = mutableListOf(),
    val dueDateUpdates: List<DueDateUpdate>? = null
)